import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {paddingTop: 10, marginHorizontal: 10, flex: 1},
  textStyle: {textAlign: 'left'},
  listSTyle: {gap: 10, paddingBottom: 10},
  flexStyle: {flex: 1},
  bottomDivider: {marginBottom: 20, marginHorizontal: -20, borderTopWidth: 1},
  buttonStyle: {
    borderRadius: 50,
  },
  refreshControl: {zIndex: 100},
  infoBox: {
    paddingVertical: 10,
    borderRadius: 10,
    marginBottom: 10,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 10,
    paddingHorizontal: 10,
  },
  disclaimerText: {
    textAlign: 'left',
  },
  text: {
    maxWidth: '90%',
  },
  iconText: {
    marginTop: 4,
  },
});
